<script lang="ts">
    import type { Snippet } from 'svelte';

    type Props = {
        children: Snippet;
        articleNumber?: string;
        productId: string;
        variationId?: string;
        listPosition: number;
        localListPosition: number;
        origin?: string;
    };

    let { children, articleNumber, productId, variationId, listPosition, localListPosition, origin, ...props }: Props =
        $props();
</script>

<article
    {...props}
    class="reptile-tile-item"
    data-article-number={articleNumber}
    data-product-id={productId}
    data-variation-id={variationId}
    data-list-position={listPosition}
    data-local-list-position={localListPosition}
    data-origin={origin}
    data-qa="reptile-product-tile"
>
    <!-- data-qa is used by team Quality -->
    {@render children()}
</article>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-tile-item {
        /*                                                                                               */
        --reptile-tile-radius: #{tokens.$oc-semantic-border-radius-200};

        overflow: hidden;
        padding: 0;
        border-radius: var(--reptile-tile-radius);
        background-color: tokens.$oc-semantic-color-background-canvas;
    }
</style>
